import React from 'react'

import { Paper, Typography, Box, Switch, Button } from '@material-ui/core'

import { Permitted } from 'components/Permissions'
import * as service from 'service'
import helpers from 'helpers'
import constants from './../../../../constants'
import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'
import SettingsNFeTableMarilia from './components/SettingsNFeTableMarilia'
import SettingsNFeForm from './components/SettingsNFeForm'

const SettingsNFe = () => {
  const snackbar = useSnackbar()
  const [enabled, setEnabled] = React.useState(false)
  const [edit, setEdit] = React.useState(false)

  const { response: responseGenerateNFe } = useFetch(
    service.recurrence.settings.get,
    {
      settingId: constants.settings.GENERATE_NFE,
    },
  )

  const {
    response: responseSimplesNacionalNFe,
    refresh: refreshSimplesNacionalNFe,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.SIMPLES_NACIONAL_NFE,
  })

  const {
    response: responseGenerateInCurrentMonthNfe,
    refresh: refreshGenerateInCurrentMonthNfe,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.GENERATE_IN_CURRENT_MONTH_NFE,
  })

  const {
    isLoading: isLoadingDaysToGenerateNFe,
    response: responseDaysToGenerateNFe,
    refresh: refreshDaysToGenerateNFe,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.DAYS_TO_GENERATE_NFE,
  })

  const {
    response: responseGenerateNFeOnInvoiceCreate,
    refresh: refreshGenerateNFeOnInvoiceCreate,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.GENERATE_NFE_ON_INVOICE_CREATION,
  })

  const {
    isLoading: isLoadingConfigGateway,
    response: responseConfigGateway,
    refresh: refreshConfigGateway,
  } = useFetch(service.recurrence.taxInvoiceSellers.getConfigGateway, {})

  React.useEffect(() => {
    if (!responseGenerateNFe) {
      return
    }

    setEnabled(!!parseInt(responseGenerateNFe.data.setting.value))
  }, [responseGenerateNFe])

  const handleSubmit = async data => {
    const {
      daysToGenerateNFe,
      simplesNacionalNFe,
      generateInCurrentMonthNfe,
      enableSimplesNacionalCheckbox,
      generateNFeOnInvoiceCreate,
      ...configGateway
    } = data

    try {
      await Promise.all([
        service.recurrence.settings.update({
          settingId: constants.settings.DAYS_TO_GENERATE_NFE,
          value: daysToGenerateNFe,
        }),

        service.recurrence.settings.update({
          settingId: constants.settings.GENERATE_IN_CURRENT_MONTH_NFE,
          value: generateInCurrentMonthNfe ? 1 : 0,
        }),

        service.recurrence.settings.update({
          settingId: constants.settings.SIMPLES_NACIONAL_NFE,
          value: enableSimplesNacionalCheckbox ? simplesNacionalNFe : '',
        }),

        service.recurrence.settings.update({
          settingId: constants.settings.GENERATE_NFE_ON_INVOICE_CREATION,
          value: generateNFeOnInvoiceCreate ? 1 : 0,
        }),

        service.recurrence.taxInvoiceSellers.setup({
          gateway: {
            configs: helpers.taxInvoiceSellers.configGatewayToArray(
              configGateway,
            ),
            gatewayCode: 'SP_MARILIA',
          },
        }),
      ])

      setEdit(false)

      refreshDaysToGenerateNFe()
      refreshSimplesNacionalNFe()
      refreshGenerateInCurrentMonthNfe()
      refreshConfigGateway()
      refreshGenerateNFeOnInvoiceCreate()

      snackbar.open({
        message: 'Configurações de Nota Fiscal alteradas com sucesso',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message: 'Erro ao alterar configurações de Nota Fiscal',
        variant: 'error',
      })
    }
  }

  const handleChangeSwitchNFe = async event => {
    if (!event.target.checked) {
      await service.recurrence.settings.update({
        settingId: constants.settings.GENERATE_NFE,
        value: 0,
      })

      setEnabled(false)

      return
    }

    await service.recurrence.settings.update({
      settingId: constants.settings.GENERATE_NFE,
      value: 1,
    })

    setEnabled(true)

    refreshDaysToGenerateNFe()
    refreshSimplesNacionalNFe()
    refreshGenerateInCurrentMonthNfe()
    refreshConfigGateway()
  }

  const handleClickButtonEdit = () => {
    setEdit(true)
  }

  const handleClose = () => {
    setEdit(false)
  }

  const isLoadingTable = isLoadingDaysToGenerateNFe || isLoadingConfigGateway

  const settings = {
    generateNFe: responseGenerateNFe && responseGenerateNFe.data.setting,
    daysToGenerateNFe:
      responseDaysToGenerateNFe && responseDaysToGenerateNFe.data.setting,
    simplesNacionalNFe:
      responseSimplesNacionalNFe && responseSimplesNacionalNFe.data.setting,
    generateInCurrentMonthNfe:
      responseGenerateInCurrentMonthNfe &&
      responseGenerateInCurrentMonthNfe.data.setting,
    generateNFeOnInvoiceCreate:
      responseGenerateNFeOnInvoiceCreate?.data.setting,
  }

  const configGateway = responseConfigGateway && responseConfigGateway.data

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Nota Fiscal Eletrônica</Typography>

        <Permitted tag="update_setting">
          <div>
            {enabled && !edit && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleClickButtonEdit}
              >
                Editar
              </Button>
            )}

            <Switch checked={enabled} onChange={handleChangeSwitchNFe} />
          </div>
        </Permitted>
      </Box>

      {enabled && !edit && (
        <SettingsNFeTableMarilia
          isLoading={isLoadingTable}
          settings={settings}
          configGateway={configGateway}
        />
      )}

      {enabled && edit && (
        <SettingsNFeForm
          settings={settings}
          configGateway={configGateway}
          handleClose={handleClose}
          onSubmit={handleSubmit}
        />
      )}
    </Paper>
  )
}

export default SettingsNFe
